export const renderFileSize = (size: number) => {
  const divide = Math.round(size / 1024);
  return divide > 1024
    ? `${(divide / 1024).toFixed(1)} MB`
    : divide < 1
    ? `${size.toFixed(1)} B`
    : `${divide.toFixed(1)} kB`;
};
